import { render, staticRenderFns } from "./ArticleTile.vue?vue&type=template&id=9d49de94&scoped=true&"
import script from "./ArticleTile.vue?vue&type=script&lang=js&"
export * from "./ArticleTile.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTile.vue?vue&type=style&index=0&id=9d49de94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d49de94",
  null
  
)

export default component.exports